(() => {
  if (typeof customElements === 'undefined' || typeof subscribe === 'undefined' || typeof PUB_SUB_EVENTS === 'undefined')
    return;

  if (customElements.get('product-price-display')) return;

  class ProductPriceDisplay extends HTMLElement {
    variantChangeUnsubscriber;

    connectedCallback() {
      this.currency = this.dataset.currency || 'USD';
      this.currencyCodeEnabled = this.dataset.currencyCodeEnabled === 'true';
      const productInfo = this.closest('product-info');
      this.watchSectionId = productInfo?.dataset.section || '';

      this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
        if (!this.watchSectionId || event?.data?.sectionId !== this.watchSectionId) return;
        const variant = event.data.variant;
        if (!variant) {
          this.setAttribute('hidden', '');
          return;
        }
        this.removeAttribute('hidden');
        this.applyVariant(variant);
      });
    }

    disconnectedCallback() {
      if (this.variantChangeUnsubscriber) this.variantChangeUnsubscriber();
    }

    formatMoney(cents) {
      const amount = (Number(cents) || 0) / 100;
      try {
        let out = new Intl.NumberFormat(undefined, {
          style: 'currency',
          currency: this.currency,
        }).format(amount);
        if (this.currencyCodeEnabled) out = `${out} ${this.currency}`;
        return out;
      } catch (e) {
        return `$${amount.toFixed(2)}`;
      }
    }

    applyVariant(variant) {
      const price = variant.price;
      const compareAt = variant.compare_at_price;

      const currentEl = this.querySelector('[data-product-price-display-current]');
      const compareWrap = this.querySelector('[data-product-price-display-compare-wrap]');
      const compareEl = this.querySelector('[data-product-price-display-compare]');

      if (currentEl) currentEl.textContent = this.formatMoney(price);

      if (compareWrap && compareEl) {
        const showCompare = compareAt && Number(compareAt) > Number(price);
        compareWrap.hidden = !showCompare;
        if (showCompare) compareEl.textContent = this.formatMoney(compareAt);
      }
    }
  }

  customElements.define('product-price-display', ProductPriceDisplay);
})();
